// extracted by mini-css-extract-plugin
export default {"passwordFormControl":"WKMfj","newPassInputs":"_5p0Os","passwordInput":"_1UkXo","validationInfo":"_1Oerc"};